import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import account from './account';
import auth from './auth';
import bank from './bank';
import dealer from './dealer';
import guestPayment from './guestPayment';
import info from './info';
import notifs from './notifs';
import page from './page';
import paymentRecord from './paymentRecord';
import queryParams from './queryParams';
import user from './user';
import userPayment from './userPayment';
import address from './address';

const rootReducer = combineReducers({
  account,
  auth,
  bank,
  dealer,
  form,
  guestPayment,
  info,
  notifs,
  page,
  paymentRecord,
  queryParams,
  routing,
  user,
  userPayment,
  address,
});

export default rootReducer;
